export default "__VITE_ASSET__Bg0v6Wbi__"